import { ReactComponent as AddUser } from "@assets/icons/add_user_icon.svg";

const AddUserIcon = (props: any): JSX.Element => {
  return (
    <AddUser
      fill={props?.sx?.color || props?.sx?.fill}
      height={props?.sx?.height || "16px"}
      width={props?.sx?.width || props?.sx?.height || "16px"}
      {...props}
    />
  );
};

export default AddUserIcon;
